import React from 'react'
import { useState,useEffect,useContext } from 'react';
 
import Moment from 'react-moment';
import Select from 'react-select';
import cogoToast from "cogo-toast";
import { FaSearch, FaSpinner, FaTimesCircle } from "react-icons/fa";

import {  getList,postList,genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS } from "../../../Constants";
import AppContext from "../../../AppContext";
import { PulseLoader } from "react-spinners";

import Calendar, {
    Appointment,
    logSelectedDatesAppointments,
  } from "react-multi-date-picker-calendar";
import { Spinner } from 'react-bootstrap';
import { Badge } from 'reactstrap';
import { getListStaffDetailsRequestBody, getLoggedInStaffAccountId } from "../../../services/Utils";

const CreateToil = () => {
  const global = useContext(AppContext);

  const [IsLoading, setIsLoading] = useState(false)
const [description, setDescription] = useState("")
const [return_date, setReturnDate] = useState(null)



    const [selectedDates, setSelectedDates] = useState([]);
    const [subject, setSubject] = useState(null)
 
const [staff_data, setstaff_data] = useState(null)
const [users, setUsers] = useState([])
const [approver2Users, setApprover2Users] = useState([])

const [request_approver_1, setRequest_approver_1] = useState(null)
const [request_approver_2, setRequest_approver_2] = useState(null)
const [engagement_name, setEngagement_name] = useState("")
 

const engagements= [
  {
      "id": "2090e518-21d0-7719-8d34-b45420f7967d",
      "title": "Emergency Deployment",
      "memo_required": true
  },
  {
      "id": "2190e518-21d0-7719-8d34-b45420f7967d",
      "title": "Ramadhan Deployment",
      "memo_required": false
  },
  {
      "id": "2290e518-21d0-7719-8d34-b45420f7967d",
      "title": "Qurbani Deployment",
      "memo_required": false
  }
               ]

 

const convert_date=(m)=>{
    var date = new Date(m);  
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
        
    let formatted=`${year}-${month}-${day}`; 
    return formatted;
}

useEffect(() => {
  const staffRequest = getListStaffDetailsRequestBody(global.get_logged_in_user());
  listUsers();
  if (staffRequest) {
    load_staff_details(staffRequest);
  } else {
    cogoToast.error("Staff ID not found on your profile. Please contact HR.", { hideAfter: 7 });
  }
}, [])

const listUsers = async () => {
  setIsLoading(true);
  const [allUsers, role2Users] = await Promise.all([
    getList(ENDPOINTS.LIST_USERS),
    getList(`${ENDPOINTS.LIST_USERS}?role=2`),
  ]);
  setUsers(allUsers);
  setApprover2Users(role2Users);
  setIsLoading(false);
};

 


const load_staff_details = (requestBody) => {
  if (!requestBody || (!requestBody.staff_code && !requestBody.staff_id)) {
    cogoToast.error("Staff ID is required.", { hideAfter: 5 });
    return;
  }

  setIsLoading(true);
  genericPost(ENDPOINTS.LIST_STAFF_DETAILS, requestBody)
    .then((res) => {
      if (res.status == 200) {
        if (res.data.status == SUCCESS_RESULT) {
          setstaff_data(res.data["data"]);
       
        } else {
          cogoToast.error(res.data.message, {});
        }
      } else {
        cogoToast.error("Connection error. Please try again.", {});
      }
      setIsLoading(false);
    })
    .catch((err) => {
      setIsLoading(false);
      cogoToast.error("Critical error occurred. Please try again.", {});
    });
};

const find_staff_by_code = (staff_id) => {
  if (!staff_id) {
    cogoToast.error("Staff ID is required.", { hideAfter: 5 });
    return;
  }

  load_staff_details({ staff_code: String(staff_id).trim() });
};

const createToil=(e)=>{
e?.preventDefault(); 

 
 
if(selectedDates.length<1 ){
  cogoToast.error("Please select at lease One Day");
  return;}
if(!engagement_name?.trim()){
  cogoToast.error("Please select an engagement.");
  return;}
 
let formatted_dates=[];
selectedDates.forEach((d)=>{
  formatted_dates.push(convert_date(d));
})

 
  let data={
    "toil_dates":  formatted_dates,
    "subject": subject,
    "description": description,
    "total_toil_days": formatted_dates.length,
    "return_to_office": return_date,
    "request_approver_1": request_approver_1.value,
    "request_approver_2": request_approver_2.value,
    "staff_id": getLoggedInStaffAccountId(global.get_logged_in_user()),
    "engagement_name": engagement_name.trim(),
}
  console.log(data)
 
  
  genericPost(ENDPOINTS.CREATE_TOIL,data)
  .then((res) => {
    
    setIsLoading(false);
    if (res.status == 200) {
 
      let responseData = res.data;
      if (res.data.status == SUCCESS_RESULT) {
        global.show_operation_result({success:true,message:"Toil submitted Successfully"})

        cogoToast.success(responseData.message);
 
 
        }
      else
      {
        cogoToast.error(responseData.message);
      }
      } else {
        cogoToast.error(res.data.message, {});
      }
    
  })
  .catch((err) => {
    setIsLoading(false);
    cogoToast.error(err.toString(), {});

    console.log(err);
  });

}
 

const getMinDate=()=>{
  try{
  var date = new Date();
 

 

return  date.setDate(date.getDate() - 1) ;
  }catch(e){alert(e)}
//.addDays(-1);
 
}

const handleDateChange = (dates) => {
    setSelectedDates(dates);
  };
  return (
    <div className="page-wrapper">
 
     
 
        <div className="page-body">
          <div className="container-xl">
            <div className="card">
            
             
              <div className="card-header">
              <h1>Toil Request Form</h1>
            </div>
                  
                   
               
                  <div className="card-body">
                  {/* <div className="input-group">

                                <input type="text"   styles={{width:"200px"}} onChange={(e)=>setstaff_code(e.target.value)} className="form-control" placeholder='SOM XXXX'/>
                                <button className="btn -btnprimary" type="button" onClick={()=>find_staff_by_code(staff_code)}><FaSearch style={{color:"white"}}></FaSearch> </button>
                              </div> */}

<hr/>

{staff_data? <>

<table className="info_table">


<tr>
  <td className="blue-bg">STAFF ID</td> <td>{staff_data?.staff_code} </td>
  <td className="blue-bg">Email Address</td> <td> {staff_data?.email}</td>
  
  </tr>
  <tr>
  <td className="blue-bg">Phone</td> <td> {staff_data?.telephone}</td>
  <td className="blue-bg"> Gender </td>  <td>{staff_data?.gender} </td>
  
  </tr>
  <tr>
  <td className="blue-bg">Passport </td> <td> {staff_data?.passport}</td>
  <td className="blue-bg">Blood Group</td> <td> {staff_data?.blood_group}</td>
  </tr>

 
 
</table>
</>:<center> <PulseLoader></PulseLoader>   </center>}
<hr/>

                     <form onSubmit={createToil}>

                    
                   <div className='row'>
                    <div className='col-md-4'>
        
     

                        
                   <b>     Select Toil Days </b>
                        <Calendar
                        // minDate={getMinDate()}
            weekdayFormat={1}
            multiSelect={true}
            handleOnChange={handleDateChange}
            OnChange={handleDateChange}
          />

          <h3> Number of Days Requested : <b> {selectedDates.length} </b> </h3>
              
                    <br/>
                    
                    </div>
                    <div className='col-md-6'>


Engagements
<select
  value={engagement_name}
  onChange={(e) => setEngagement_name(e.target.value)}
  className="form-control"
>
  <option value="">Select Engagement</option>
  {engagements.map((e) => (
    <option key={e.id} value={e.title}>
      {e.title}
    </option>
  ))}
</select>

 


subject 
<input type='text' className='form-control' onChange={(e)=>setSubject(e.target.value)} ></input>


                    Description  
                        <textarea rows={10} className='form-control'  onChange={(e)=>setDescription(e.target.value)}>

                        </textarea>

Return To Office Date

                        <input type='date' className='form-control' onChange={(e)=>setReturnDate(e.target.value)} ></input>

{/* {JSON.stringify(leave_types)} */}


 Approver 1
 <Select
        value={request_approver_1}
         onChange={setRequest_approver_1}
        options= {users?.map((u)=>{  
          return { value: u.value, label: u.text }  
          })}
      />

Approver 2
<Select
        value={request_approver_2}
         onChange={setRequest_approver_2}
        options={approver2Users?.map((u) => ({
          value: u.value,
          label: u.text,
        }))}
      />
<br/>


<button type='submit'  disabled={staff_data==null || return_date==null ||  description==null  ||  subject==null || selectedDates?.length < 1 || !engagement_name?.trim()}  
                        className="btn btn-primary btn-lg" style={{width:"100%"}}> Create Toil </button>

                     
                       



                    </div>

          


                   </div>
                 


                  </form>
                  
 

                  </div>
  
 
 
                   
           
              </div>
            </div>
          </div>
        </div>
       
     
  )
}

export default CreateToil